import React from 'react';
import { withTranslation } from 'react-i18next';
import InputFilter from '../../../components/Filters/InputFilter';
import { FilterProps } from './FilterProps';

export type NetAmountFilterProps = FilterProps

const CardNumberFilter = (
    {
        queryParams,
        t,
        onChange,
    }: NetAmountFilterProps
) => {
    const value = queryParams.get('card_number') || '';

    return (
        (<InputFilter
            label={value ? `**** **** **** ${value}` : ''}
            name="card_number"
            title={t('orders.filter.card_number.title')}
            value={value}
            placeholder={t('orders.filter.card_number.placeholder')}
            validate={(value: string) => {
                const digits = value.replace(/[^0-9]/g, '');
                if (digits.length === 4 || digits.length === 0) {
                    return undefined;
                }
                return 'error';
            }}
            maxlength={4}
            options={{
                blocks: [4],
                numericOnly: true,
                numeralPositiveOnly: true,
            }}
            autoFocus={true}
            onApply={(value) => {
                onChange({ card_number: value ? [value] : []});
            }}
            onDelete={(_) => {
                onChange({
                    card_number: [],
                });
            }}
        />)
    );
};

export default withTranslation()(CardNumberFilter);
